import {
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/card";
import { Card } from "flowbite-react";
import React from "react";
import ReviewCard from "./ReviewCard";

const ViewReview = ({ review }: any) => {
  return (
    <Card className="w-full p-0 border-0 shadow-none">
      <CardHeader>
        <CardTitle className="capitalize">View Review</CardTitle>
        <CardDescription>Check full detail of the review</CardDescription>
      </CardHeader>
      <CardContent>
        <ReviewCard data={review} />
      </CardContent>
    </Card>
  );
};

export default ViewReview;
